import React from 'react';
import { CalendarDaysIcon, ClipboardCheckIcon, FileTextIcon, GalleryHorizontalEndIcon, LightbulbIcon } from 'lucide-react';
import { Reveal } from './ui/Reveal';
import { BONUS_VALUE, bonuses } from '../data/content';
const ICONS = {
  file: FileTextIcon,
  check: ClipboardCheckIcon,
  calendar: CalendarDaysIcon,
  cards: GalleryHorizontalEndIcon,
  bulb: LightbulbIcon
};

/* Colores de cada bono, igual que en la portada del pack */
const BONUS_COLORS = ['bg-brand-red text-white', 'bg-brand-yellow text-brand-ink', 'bg-brand-green text-brand-ink', 'bg-brand-blue text-white', 'bg-brand-violet text-white'];
export function BonusesSection() {
  return <section aria-labelledby="bonos" className="bg-white text-brand-ink" data-id="element-27" data-mp="19kknearcxjx7">
      <div className="mx-auto max-w-2xl px-3 py-5 text-center sm:px-5" data-id="element-28" data-mp="19mdtnoy2624o">
        <h2 id="bonos" className="font-display text-3xl font-bold leading-tight text-brand-blue sm:text-4xl" data-id="element-29" data-mp="1nklnvp3pmpc5">
          <span className="rounded-md bg-brand-yellow px-2 text-brand-ink" data-id="element-30" data-mp="3pqbqf3x4yixf">
            5 Bonos incluidos
          </span>
        </h2>
        <p className="mx-auto mt-2 max-w-xl text-sm leading-snug text-brand-muted" data-id="element-31" data-mp="3tr5go3y1w9th">
          Y además recibís 5 recursos prácticos —{' '}
          <strong className="font-bold text-brand-red" data-id="element-32" data-mp="2kb3j7q2new1">GRATIS</strong> con tu
          compra.
        </p>

        <ul className="mt-3 grid gap-2 sm:grid-cols-2" data-id="element-33" data-mp="7imb1bsw9db3">
          {bonuses.map((bono, i) => {
          const Icon = ICONS[bono.icon];
          return <Reveal key={bono.title} as="li" delay={i * 0.03} className="flex h-full flex-col overflow-hidden rounded-xl border-2 border-brand-yellow bg-white text-left" data-id="element-34" data-mp="gkc3mkyiiiag" data-mpi={i}>
                <span className={`flex items-center gap-1.5 px-2.5 py-1 font-display text-sm font-bold uppercase tracking-wide ${BONUS_COLORS[i]}`} data-id="element-35" data-mp="va9vpbzkbs4x">
                  <Icon size={13} aria-hidden="true" data-id="element-36" data-mp="1079xhapdq8q8" />
                  Bono {i + 1} — Gratis
                </span>
                <div className="flex flex-1 flex-col p-2.5" data-id="element-37" data-mp="5m5vmgttjpot">
                  <h3 className="text-sm font-bold uppercase leading-tight" data-id="element-38" data-mp="5nz1htwly5vr">
                    {bono.title}
                  </h3>
                  <p className="mt-0.5 text-xs leading-snug text-brand-muted sm:text-sm" data-id="element-39" data-mp="fkbv6rs5kjqi">
                    {bono.desc}
                  </p>
                  <p className="mt-auto pt-1.5 text-sm font-bold uppercase tracking-wide text-brand-muted line-through decoration-brand-red decoration-2" data-id="element-40" data-mp="taoxoem9z68g">
                    {bono.value}
                  </p>
                </div>
              </Reveal>;
        })}
        </ul>

        <div className="mt-3 inline-block rounded-xl border-2 border-dashed border-brand-yellow bg-brand-blue px-3 py-2 font-display text-sm font-bold uppercase leading-tight text-white sm:text-base" data-id="element-41" data-mp="ybuvgqusljou">
          <p data-id="element-42" data-mp="3037zzesulpkd">💰 Valor total de los 5 bonos: {BONUS_VALUE}</p>
          <p className="mt-0.5 text-brand-yellow" data-id="element-43" data-mp="1fk5ii3mdfnop">
            🔥 Hoy los 5 están incluidos gratis.
          </p>
        </div>
      </div>
    </section>;
}